module.exports = __webpack_public_path__ + "img/m-banner-csrrksao-th-TH.e8eaf239.jpg";